/**
 * This is a wrapper component for different Layouts. Footer content should be added to this wrapper.
 */
import { Box } from '@mui/material';
import classNames from 'classnames';
import React, { memo } from 'react';

import { isCordova } from '../../../util/mobile/deviceDetection';

const rootSx = {
  width: '100%',
  position: 'relative',
};

/**
 * @typedef {object} LayoutWrapperFooterProps
 * @property {string | null} [className] - Additional class to be added to the root element.
 * @property {string | null} [rootClassName] - Additional class to be added to the root element.
 * @property {object | ((theme: object) => object) | null} [sx] - Additional MUI sx styles merged onto the root element.
 * @property {React.JSX.Element | null} children - Collection of children to be rendered.
 */

const LayoutWrapperFooterComponent = ({
  className = null,
  rootClassName = null,
  sx = null,
  children,
}) => {
  if (isCordova()) return null; // only display in desktop

  const classes = classNames(rootClassName, className);
  const rootStyle = rootClassName ? undefined : rootSx;

  return (
    <Box className={classes} sx={[rootStyle, sx].filter(Boolean)}>
      {children}
    </Box>
  );
};

LayoutWrapperFooterComponent.displayName = 'LayoutWrapperFooter';

const LayoutWrapperFooter = memo(LayoutWrapperFooterComponent);

export default LayoutWrapperFooter;
